import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=608e9bfe&scoped=true"
import script from "./customerDetail.vue?vue&type=script&lang=js"
export * from "./customerDetail.vue?vue&type=script&lang=js"
import style0 from "./customerDetail.vue?vue&type=style&index=0&id=608e9bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e9bfe",
  null
  
)

export default component.exports